define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LicenseItemTypeDomain = void 0;
    class LicenseItemTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: LicenseItemTypeDomain.Checklist, value: "Checklist" },
                    { key: LicenseItemTypeDomain.AdditionalCondition, value: "Additional Condition" },
                    { key: LicenseItemTypeDomain.StandardCondition, value: "Standard Condition" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[LicenseItemTypeDomain.Checklist] = 0;
                this.KeyIndex[LicenseItemTypeDomain.AdditionalCondition] = 1;
                this.KeyIndex[LicenseItemTypeDomain.StandardCondition] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Checklist"] = 0;
                this.ValueIndex["Additional Condition"] = 1;
                this.ValueIndex["Standard Condition"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.LicenseItemTypeDomain = LicenseItemTypeDomain;
    Object.defineProperty(LicenseItemTypeDomain, "Checklist", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(LicenseItemTypeDomain, "AdditionalCondition", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(LicenseItemTypeDomain, "StandardCondition", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(LicenseItemTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
